<div class="rotation tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.rotation' | translate }}
    </h5>
    <div class="corner-radius-input-container">
        <app-editor-input-text
            name="rotation"
            [label]="'mimic.design.rotation.label' | translate"
            [value]="rotation"
            [type]="rotation == MIXED_STRING ? 'text' : 'number'"
            frontIcon="rotation"
            unit="°"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handleRotationChange($event)"
            [maxValue]="ROTATION_MAX"
            (onInputKeyDown)="validRotationKeyDown($event)">
        </app-editor-input-text>
    </div>
</div>
